import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import ApiService from '../../services/api-service';
import notifier from '../Notifier';
import { getErrorString } from '../../constants/function';
import { format as dtFormat } from 'date-fns';
import { Images } from "../../assets/common";

export default function SkDrawerCalendar() {
    const [ selectedDate, setSelectedDate ] = React.useState( new Date() );
    const [ streamCountList, setStreamCountList ] = useState( [] );
    const [ streamList, setStreamList ] = useState( [] );
    const streamRef = React.useRef( [] );

    React.useEffect(() => {
        getStreamCountList();
        getStreamList();
    }, [selectedDate] );

    const getStreamCountList = async () => {
        try {
            const nowDate = {
                year: selectedDate.getFullYear(),
                month: selectedDate.getMonth() + 1
            };

            const response = await ApiService.SCHEDULE_LIVESTREAMS( nowDate );
            setStreamCountList( [ ...response[ "result" ] ] );
            streamRef.current = response[ "result" ];
        } catch (error) {
            notifier.error( getErrorString( error ) );
        }
    };

    const getStreamList = async () => {
        try {
            const dateText = dtFormat(selectedDate, 'yyyy-MM-dd');
            const response = await ApiService.SCHEDULE_LIVESTREAMS_DATE(
                { date: dateText, pageNo: 1, pageSize: 3000 } // NO_MAGIC
            );
            setStreamList( [ ...response[ "result" ] ] );
        } catch (error) {
            notifier.error( getErrorString( error ) );
        }
    };

    const dateTemplate = (checkDate) => {
        const date = new Date(checkDate.year, checkDate.month, checkDate.day);
        const dateText = dtFormat(date, 'yyyy-MM-dd');

        let streamCountPair = streamCountList && streamCountList.find(item => item.date === dateText);
        let streamCount = (streamCountPair !== undefined) ? streamCountPair.events : 0;

        let baseStyle = {
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '30px',
            height: '30px',
            lineHeight: '30px',
            textAlign: 'center',
            borderRadius: '50%',
            color: '#fff',
            backgroundColor: 'transparent',
            fontSize: '16px',
            transition: 'all 0.3s'
        };

        if (streamCount > 0) {
            const size = 20 + (streamCount * 5); // NO_MAGIC
            return (
                <strong style={{
                    ...baseStyle,
                    color: '#000000',
                    backgroundColor: '#99ffcc',
                    width: `${size}px`,
                    height: `${size}px`,
                    lineHeight: `${size}px`
                }}>
                    {checkDate.day}
                </strong>
            );
        } else {
            return (
                <span style={baseStyle}>
                {checkDate.day}
            </span>
            );
        }
    };

    const EventCard = ({ event }) => {
        const [img, setImg] = useState();

        useEffect(() => {
            setImg( event.thumbnailImg ? event.thumbnailImg.filePath : Images.default_playlist );
        }, [event]);

        let dateObj = new Date(event.startDate);
        const minutes = dateObj.getMinutes();
        const timeFormat = minutes === 0 ? "haaa" : "h:mmaaa";
        const startText = dtFormat(dateObj, timeFormat);

        return (
            <div className="min-w-[100px] max-w-[100px] p-2 border border-gray-950 rounded-lg">
                <img src={img} alt={event.title || 'Playlist'} className="w-full h-auto mb-4 bg-slate-500" />
                <p className="text-white font-bold">{event.title}</p>
                <p className="text-white">{event.description}</p>
                <div className="text-gray-700">{startText}</div>
            </div>
        );
    };

    return (
        <>
            <p className="text-center text-xl font-bold pt-2 pb-2"> Calendar </p>
            <div className="p-2 relative" style={{ height: '450px' }}>
                <div style={{ transform: "translateX(-50%) scale(0.7)", transformOrigin: "top center",
                    position: "absolute", top: 25, left: "50%", width: "115%" }}>
                    <Calendar
                        style={{ width: "300%" }}
                        inline
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.value)}
                        dateTemplate={dateTemplate}
                    />
                </div>
                <div className="w-full flex flex-wrap justify-center gap-4" style={{ marginTop: "375px" }}>
                    {streamList.map(item => (
                        <EventCard key={item.id} event={item} />
                    ))}
                </div>
            </div>
        </>
    );
}